import {Howl} from 'howler';

type InitSoundData = {
  [sound: string]: string;
}

type SoundMap = {
  [sound: string]: Howl
};



function playSound(soundMap: SoundMap, soundArr: string[], index = 0) {
    const soundKey = soundArr[index];
    if (!soundKey) return;

    const sound = soundMap[soundKey];
    sound.once('end', () => {
      playSound(soundMap, soundArr, index + 1);
    })

    sound.play();
}


export default class SongFactory {
  protected soundMap: SoundMap;

  constructor(initSoundData: InitSoundData) {
    this.soundMap = {}

    Object.keys(initSoundData).forEach((key) => {
      const url = initSoundData[key]
      this.soundMap[key] = new Howl({ src: [url] });
    });
  }

  playSong(soundArray: string[]) {
    const unexpendedSound = soundArray.find(
      (sound) => !this.soundMap[sound]
    );

    if (unexpendedSound) {
      throw new Error(`Unexpended sound ${unexpendedSound}`);
    }


    const soundMap = this.soundMap;
    playSound(soundMap, soundArray)
  }
};
